var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconIndividual4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24.981,
    height: 30,
    viewBox: "0 0 24.981 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{clip-path:url(#a);}.c{fill:#1855f1;}.d{fill:#7097f6;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 24.981,
    height: 30
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M24.382,0H.65A.662.662,0,0,0,0,.65V18.736c0,3.947,2.848,6.8,6.245,8.744a28.129,28.129,0,0,0,6.1,2.5c.1,0,.2.05.3,0a26.346,26.346,0,0,0,6.1-2.5c3.4-1.949,6.245-4.8,6.245-8.744V.65a.655.655,0,0,0-.6-.65m-.65,18.736c0,2.948-1.9,5.5-5.6,7.644a29.255,29.255,0,0,1-5.646,2.348,23.7,23.7,0,0,1-5.646-2.348c-3.7-2.149-5.6-4.7-5.6-7.644V1.249H23.733Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M10.594,28.185a22.027,22.027,0,0,0,4.646,1.8h.3a19.249,19.249,0,0,0,4.647-1.8c3.147-1.7,4.846-3.947,4.846-6.445V6.9a.661.661,0,0,0-.65-.649H6.4a.661.661,0,0,0-.649.649V21.789c.05,2.5,1.7,4.7,4.847,6.4M7.046,7.55H23.783V21.789c0,4.6-7.245,6.7-8.344,7-1.1-.3-8.344-2.348-8.344-7-.05,0-.05-14.239-.05-14.239",
    transform: "translate(-2.899 -3.153)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M20.791,21.257v6.3a.65.65,0,0,0,1.3,0v-6.3a3.746,3.746,0,0,0-.6-7.444,3.871,3.871,0,0,0-3.848,3.8,3.7,3.7,0,0,0,3.148,3.647m.6-6.145a2.5,2.5,0,1,1-2.5,2.5,2.474,2.474,0,0,1,2.5-2.5",
    transform: "translate(-8.9 -6.968)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIndividual4);
export default __webpack_public_path__ + "static/media/Icon-individual-4.e789e0dfcf37ce1f92d648f4afdd1ba4.svg";
export { ForwardRef as ReactComponent };